import { render, staticRenderFns } from "./DiversificationCard.vue?vue&type=template&id=24071e9e&"
import script from "./DiversificationCard.vue?vue&type=script&lang=js&"
export * from "./DiversificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports